import _ from 'lodash';
import '../css/main.css';
import '../css/animate.css';
import $script from 'scriptjs';
import Remote from '../js/remote';
import integrate from '../js/artoolkit.three';


let preload = null;
var imagesToDisplay = ['Data/render/C-azzurro.png', 'Data/render/C-nera.png', 'Data/render/C-verde.png',
	'Data/render/C-rossa.png', 'Data/render/C-arancio.png'
];
var selectedImage = 0;
var myElement = document.getElementById('removeinput');


var selectedObject = null;
var mobileHack = false;
var INPUT_MODES = {
	NONE: 0,
	ROTATION_START: 4,
	ROTATION: 1,
	PAN: 2,
	SCALE: 3,
	SCALE_START: 5
};
var inputMode = -1;
var inputStart = {
	x: 0,
	y: 0
};
var firstRot = true;

var currentSelected = 0;
var models = null;
var scene = null;
var mixer = null;
var modelTexture = null;
var markerVideo = null;
var selectedType = 'image';
var enabled = false;
var loaded = true;
var videoEnabled = false;

var Markers = Remote();
var raycaster;
var mouse;

Markers.loadParameters((p) => {
	// Sentry.init({
	// 	dsn: p.sentryUrl
	// });
})

$script([
	'https://browser.sentry-cdn.com/4.0.3/bundle.min.js',
	'js/third_party/three.js/three.min.js',
	'build/artoolkit.min.js',
	'js/third_party/hammer.min.js',
	'js/third_party/inflate.js',
	'js/third_party/preload.min.js'], () => {
		console.log("Preload");
		raycaster = new THREE.Raycaster();
		mouse = new THREE.Vector2();
		$script(['js/third_party/ColladaLoader.js',
			'js/third_party/OrbitControls.js',
			'js/third_party/GLTFLoader.js',
			'js/third_party/HDRCubeTextureLoader.js',
			'js/third_party/PMREMGenerator.js',
			'js/third_party/RGBELoader.js',
			'js/third_party/PMREMCubeUVPacker.js',
			'js/third_party/FBXLoader.js',
			'js/third_party/OBJLoader.js'], () => {
				console.log("LOADED DEPENDENCIES");
				preload = new createjs.LoadQueue();
				preloadAssets();
				initInteraction();
			});
	});

var hammertime = null;
function initInteraction() {
	hammertime = new Hammer(myElement, {
		prevent_default: true,
	});

	hammertime.get('pinch').set({
		enable: true
	});

	hammertime.get('tap').set({
		enable: true
	});

	hammertime.get('rotate').set({
		enable: true
	});

	hammertime.on('tap', function (e) {
		window.scene.traverse(m => {
			if (m.type == 'PerspectiveCamera') {
				var rect = e.target.getBoundingClientRect();
				var x = e.pointers[0].clientX - rect.left; //x position within the element.
				var y = e.pointers[0].clientY - rect.top; //y position within the element.
				if (window.mobileHack) {
					mouse.y = -(x / rect.width) * 2 + 1;
					mouse.x = -(y / rect.height) * 2 + 1;
				} else {
					mouse.x = (x / rect.width) * 2 - 1;
					mouse.y = -(y / rect.height) * 2 + 1;
				}

				raycaster.setFromCamera(mouse, m);

				var intersects = raycaster.intersectObjects(window.scene.children, true);

				for (var i = 0; i < intersects.length; i++) {
					intersects[i].object.traverseAncestors(k => {
						if (selectedType == 'model') {
							if (k.userData && k.userData.root == true) {
								console.log('selected ', k);
								selectedObject = k;
								return;
							}
						}
						if (selectedType == 'image') {

							var texLoader = new THREE.TextureLoader();
							texLoader.setCrossOrigin("anonymous");
							selectedImage = (selectedImage + 1) % imagesToDisplay.length;
							imageplane.material.map = texLoader.load(imagesToDisplay[selectedImage]);
						}
					})


				}
			}
		})
	})

	hammertime.on('pinch pinchend pinchstart doubletap', function (e) {
		console.log('captured event:', e.type, e);
		switch (e.type) {
			case 'pinch':
				if (selectedObject) {
					var scale = e.scale;
					selectedObject.scale.set(scale, scale, scale);
				}
				break;
		}
		e.preventDefault();
	});

	hammertime.on('rotate rotatestart rotateend rotatemove rotatecancel', function (e) {
		console.log('captured event:', e.type, e);
		switch (e.type) {
			case 'rotate':
				if (selectedObject) {
					var rotation = e.rotation * Math.PI / 180;
					selectedObject.rotation.y = -rotation;
				}
				break;
		}
		e.preventDefault();
	});
}

function continueLoad(p) {
	var renderer = new THREE.WebGLRenderer({
		antialias: true,
		logarithmicDepthBuffer: true,
	});
	renderer.gammaOutput = true;
	renderer.gammaInput = true;
	renderer.toneMappingExposure = 1;
	renderer.setPixelRatio(window.devicePixelRatio);
	document.getElementById('removeinput').appendChild(renderer.domElement);
	debugger;
	integrate();
	window.setTimeout(() => {
		window.videoController = ARController.getUserMediaThreeScene({
			maxARVideoSize: 640,
			cameraParam: 'Data/camera_para-iPhone 5 rear 640x480 1.0m.dat',
			onSuccess: function (arScene, arController, arCamera) {
				window.controller = arController;
				window.arScene = arScene;
				window.arCamera = arCamera;

				arController.setPattRatio(p.pattRatio);
				var clock = new THREE.Clock();
				document.body.className = arController.orientation;

				if (arController.orientation === 'portrait') {
					var w = (window.innerWidth / arController.videoHeight) * arController.videoWidth;
					var h = window.innerWidth;
					renderer.setSize(w, h);
					renderer.domElement.style.width = 'auto';
					renderer.domElement.style.height = '100%';
					renderer.domElement.style.paddingBottom = (w - h) + 'px';
					window.mobileHack = true;
				} else {
					if (/Android|mobile|iPad|iPhone/i.test(navigator.userAgent)) {
						renderer.setSize(window.innerWidth, (window.innerWidth / arController.videoWidth) * arController.videoHeight);
					} else {
						renderer.setSize(arController.videoWidth, arController.videoHeight);
						document.body.className += ' desktop';
					}
				}



				window.scene = arScene.scene;
				window.setTimeout(() => {

					Markers.loadMarkers((markers) => {
						var imageEnabled = videoEnabled = false;

						if (markers.length === 0) return;
						markers.forEach(marker => {
							console.log('loading marker?', marker.fileName);
							arController.loadMarker(marker.fileName, (markerId) => {
								var markerRoot = arController.createThreeMarker(markerId, 1, 0.3);
								markerRoot.addEventListener('markerLost', () => {
									console.log("marker", markerRoot, 'lost');
								});
								let texLoader = new THREE.TextureLoader();
								texLoader.setCrossOrigin("anonymous");
								marker.resources.forEach(res => {
									console.log('loading resource', res);
									if (res.type === 'image') {
										var implane = new THREE.Mesh(
											new THREE.PlaneGeometry(1, 1),
											new THREE.MeshBasicMaterial({
												transparent: true,
												opacity: 1
											})
										);
										implane.material.shading = THREE.FlatShading;
										implane.position.set(1, 1, 0);
										implane.visible = true;
										implane.material.map = texLoader.load(res.url);
										implane.material.map.wrapS = THREE.RepeatWrapping;
										implane.scale.set(3.5, 3.5, 1.1);
										// implane.rotateZ(Math.PI/2);
										implane.userData.type = res.type;
										implane.userData.data = res;
										window.imageplane = implane;
										markerRoot.add(implane);
										imageEnabled = true;
									}
									if (res.type === 'video') {
										var video = document.createElement('video');
										video.autoplay = true;
										video.controls = false;
										video.setAttribute('playsinline', 'playsinline');
										video.setAttribute('webkit-playsinline', 'webkit-playsinline');
										video.crossOrigin = "anonymous";
										video.src = res.url;
										video.height = 0;

										window.markerVideo = video;

										document.body.insertBefore(video, document.body.firstChild);

										var videoTexture = new THREE.VideoTexture(video);
										videoTexture.minFilter = THREE.LinearFilter;
										videoTexture.magFilter = THREE.LinearFilter;
										videoTexture.format = THREE.RGBFormat;
										videoTexture.flipX = true;

										window.videoTexture = videoTexture;

										var cylinderMaterial = new THREE.MeshBasicMaterial({
											map: videoTexture
										});
										var cylinderSurface = new THREE.Mesh(
											new THREE.PlaneGeometry(1, 1),
											cylinderMaterial
										);
										cylinderSurface.material.shading = THREE.FlatShading;
										cylinderSurface.visible = false;
										// cylinderSurface.rotateZ(Math.PI / 2);
										cylinderSurface.scale.set(3.5, 3.5, 1.1);
										cylinderSurface.position.set(1, 1, 0);
										cylinderSurface.userData.type = res.type;
										markerRoot.add(cylinderSurface);

										videoEnabled = true;
									}
									if (res.type === 'model') {
										var objectRoot = new THREE.Object3D();
										markerRoot.add(objectRoot);

										objectRoot.userData.root = true;

										// Instantiate a loader
										var loader = new THREE.GLTFLoader();

										// Load a glTF resource
										loader.load(
											// resource URL
											"https://s3.eu-central-1.amazonaws.com/cloud.myarstudio.static/demostore/braun_ks20_orange.gltf",
											// called when the resource is loaded
											function (gltf) {
												objectRoot.add(gltf.scene);
												window.objectRoot = objectRoot;
												objectRoot.traverse(m => {
													m.userData.type = 'model';
												});

												var hdrUrls = ['posx.hdr', 'negx.hdr', 'posy.hdr', 'negy.hdr', 'posz.hdr', 'negz.hdr'];
												var hdrCubeMap = new THREE.HDRCubeTextureLoader()
													.setPath('./Data/textures/')
													.load(THREE.UnsignedByteType, hdrUrls, function () {

														var pmremGenerator = new THREE.PMREMGenerator(hdrCubeMap);
														pmremGenerator.update(renderer);

														var pmremCubeUVPacker = new THREE.PMREMCubeUVPacker(pmremGenerator.cubeLods);
														pmremCubeUVPacker.update(renderer);

														var hdrCubeRenderTarget = pmremCubeUVPacker.CubeUVRenderTarget;

														pmremGenerator.dispose();
														pmremCubeUVPacker.dispose();

														gltf.scene.traverse(m => {
															if (m.type === 'Mesh') {
																m.material.envMap = hdrCubeRenderTarget.texture;
																m.material.envMapIntensity = 2.0;
															}
														})
													});

												objectRoot.visible = false;
												objectRoot.scale.set(0.1, 0.1, 0.1);
												objectRoot.position.set(1, -1, 1);

												var light = new THREE.PointLight(0xffffff, 1, 100);
												light.position.set(20, 1.5, 1.1);
												objectRoot.add(light);
												// selectDisplay('image');

											},
											// called while loading is progressing
											function (xhr) {

												console.log((xhr.loaded / xhr.total * 100) + '% loaded');

											},
											// called when loading has errors
											function (error) {

												console.log('An error happened', error);

											}
										);

										imageEnabled = true;
									}
								});
								arScene.scene.add(markerRoot);
							});
						});
					}, 1000);
				});

				const tick = function () {
					const delta = clock.getDelta();
					if (arScene != null) {
						arScene.process();
						arScene.renderOn(renderer);
						if (mixer != null)
							mixer.update(delta);
						// console.log("need update");
						// if (window.videoTexture)
						// 	window.videoTexture.needsUpdate = true;
					}

					requestAnimationFrame(tick);
				};

				tick();
			}
		});
	}, 1000);
}

window.ARThreeOnLoaded = function (orientation) {
	Markers.loadParameters((p) => {
		continueLoad(p);
	})
};

window.selectDisplay = function (type) {
	if (window.selectedType == 'model') {
		window.objectRoot.rotateX(Math.PI / 2);
	}

	window.selectedType = type;
	window.scene.traverse(m => {
		console.log(m.userData.type);
		if (m.userData.type != undefined) {
			if (m.userData.type == type) {
				m.visible = true;
			} else {
				m.visible = false;
			}
			console.log('setting ', m, 'visibile', m.visible);
		}
	});
	if (type === 'video') {
		window.markerVideo.play();
	} else {
		window.markerVideo.pause();
	}
};

function canvasCheck() {
	var elms = document.getElementsByTagName("canvas");
	for (var i = 0; i < elms.length; i++) {
		var ele = elms[i];
		// ele.style['display'] = 'none';
		ele.parentElement.removeChild(ele);
	};
}

function doOrientationChangeCheck() {
	// After orientationchange, add a one-time resize event
	if (window.orientation != null && window.orientation.angle == 0 || window.orientation == 0) {
		// enabled = false;
		// document.getElementById('loading').innerText = 'Loading...';
	} else {
		// document.getElementById('loading').innerText = 'Loading...';
	}

	if (window.orientation != null && window.orientation.angle == 0 || window.orientation == 0) {
		// enabled = false;
		// document.getElementById('loading').innerText = 'Loading...';
		if (window.controller) {
			if (window.videoController !== undefined) {
				window.videoController.srcObject.getTracks()[0].stop();
				window.videoController.remove();
			}
			window.controller.dispose();
		}

		canvasCheck();

		window.setTimeout(() => {
			if (window.ARThreeOnLoaded != null)
				window.ARThreeOnLoaded('portrait');
		}, 1000);
	} else {
		// if (loaded || !enabled) {
		{
			// document.getElementById('loading').innerText = '';
			enabled = true;
			if (window.controller) {
				if (window.videoController !== undefined) {
					window.videoController.srcObject.getTracks()[0].stop();
					window.videoController.remove();
				}
				window.controller.dispose();
			}
			canvasCheck();

			window.setTimeout(() => {
				if (window.ARThreeOnLoaded != null)
					window.ARThreeOnLoaded('landscape');
			}, 1000);
		}
	}

}

function handleFileComplete(event) {
	document.getElementById("loading").className = "centered fadeOut animated";
	window.setTimeout(() => {
		// let digitus = preload.getResult("digitus");
		// let templateContainer = document.createElement("div");
		// templateContainer.className = "template opacity-10 centered";
		// templateContainer.appendChild(digitus);
		// document.body.appendChild(templateContainer);
		// template = templateContainer;
		document.getElementById("controls").className = "animated fadeIn";
	}, 1000);

	window.addEventListener("orientationchange", doOrientationChangeCheck);
	window.setTimeout(() => doOrientationChangeCheck(), 1000);
}

function preloadAssets() {
	preload.on("complete", handleFileComplete, this);
	var resToLoad = [];
	resToLoad.push({ id: "tex-a", src: "/Data/render/C-azzurro.png" });
	resToLoad.push({ id: "tex-b", src: "/Data/render/C-nera.png" });
	resToLoad.push({ id: "tex-c", src: "/Data/render/C-arancio.png" });
	resToLoad.push({ id: "tex-d", src: "/Data/render/C-verde.png" });
	resToLoad.push({ id: "tex-e", src: "/Data/render/C-rossa.png" });
	Markers.loadMarkers((markers) => {
		/*for(let i = 0; i < markers.length; i++) {
		    resToLoad.push({id: "marker", src: markers[i].fileName});
		    for(let k = 0; k < markers[i].resources.length; k++){
		        var res = markers[i].resources[k];
		        resToLoad.push({id: "res_" + i + "_" + res.type, src: res.url});
		    }
		}*/
		preload.loadManifest(resToLoad);
	});
}
